<template>
  <div>
    <loading :loading="isLoading">
      <b-card header="Related extract data">
        <error :error="error"/>
        <div v-if="page">
          <b-list-group flush>
            <b-list-group-item>
              <discounts :discounts="page.Discounts"/>
            </b-list-group-item>
            <b-list-group-item>
              <blue-badge :data="page.BlueBadges"/>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-card>
    </loading>
  </div>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'
import Discounts from '../extract_views/Discounts.vue'
import BlueBadge from '../extract_views/BlueBadge.vue'

export default {
  components: { Loading, Error, Discounts, BlueBadge },
  props: ['reference'],
  data() {
    return {
      isLoading: true,
      page: null,
      error: null,
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'spd_multiple_blue_badge',
      parameters: {
        reference: this.reference,
      },
    })
    .then((page) => { this.page = page; this.isLoading = false; })
    .catch((e) => { this.error = e.message; this.isLoading = false; });
  }
}
</script>

